import React from 'react'
import styled from 'styled-components'

type Props = {
  className?: string
}
export const RadioFormGroup = ({
  children,
  className,
}: WithChildren<Props>): JSX.Element => {
  return <Wrapper className={className}>{children}</Wrapper>
}

const Wrapper = styled.div`
  display: flex;

  div:not(:first-child) {
    margin-left: 1.5rem;
  }
`
